import { useContext } from "react";
import NavBarComp from "../../components/navbar/navbar";
import { CartContext } from "../../App";
import './contact.scss'
export interface ContactProps {

}

function Contact(props: ContactProps) {
    const cartContext = useContext(CartContext);

    return (
        <div className="contact">
            <NavBarComp active="contact" nCart={cartContext.cart ? cartContext.cart.items_count : 0}></NavBarComp>
            <div className="container">
                <div className="row mt-4">
                    <div className="col col-12">
                        <p className="intestazione">DOVE SIAMO</p>
                        <p><i className="bi bi-geo-alt"></i> Via Vincenzo Montefusco, n. 14, 84013 Cava de' Tirreni (SA)</p>
                        <p><i className="bi bi-telephone"></i> 089 287 3788</p>
                        <p><i className="bi bi-envelope"></i> bellacosawinefood@yahoo.com</p>
                        <p>P.IVA 05574590658</p>

                        <p className="mt-4">seguici su
                            <button className="btn p-1"><i className="bi bi-facebook" onClick={() => {
                                window.open(
                                    'https://www.facebook.com/bellacosacavadetirreni/',
                                    '_blank'
                                )
                            }}></i></button>
                            <button className="btn p-1"><i className="bi bi-instagram"
                                onClick={() => {
                                    window.open(
                                        "https://www.instagram.com/bellacosa_winefood/",
                                        '_blank'
                                    )
                                }}></i></button>
                        </p>
                        
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Contact